














import { Component, Mixins, Watch } from 'vue-property-decorator';
import RatesTable from '@/components/rates/RatesTable.vue';
import LocationsTable from '@/components/locations/LocationsTable.vue';
import Mixin from '@/mixins/base';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import { resolveModule } from '@/store';
import { LocationsModule } from '@/store/dashboard/locations/LocationsModule';

@Component({
  mixins: [Mixin],
  components: {
    'rates-table': RatesTable,
    'locations-table': LocationsTable,
  }
})
export default class Locations extends Mixins(Mixin) {
  private readonly buildingsModule: BuildingsModule = resolveModule(BuildingsModule);
  private readonly locationsModule: LocationsModule = resolveModule(LocationsModule);

  private loading = false;

  get buildingId(): number {
    return Number(this.$route.params.buildingId);
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    await this.buildingsModule.FetchSingle(this.buildingId);
    await this.locationsModule.Fetch(this.buildingId);
    this.loading = false;
  }

  @Watch('buildingId', { immediate: true })
  private async buildingChangedHandler(): Promise<void> {
    await this.loadData();
  }
}
